<template>
    <div class="contenedor_modal">
        <div class="contenedor_modal_cuerpo">
            <div class="contenedor_modal_cabecera">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="cerrar">Cerrar</button>
            </div>
            <b-container fluid="">
                <form @submit.prevent="actualizar">

                    <b-row>
                        <div class="col-sm-12 mt-3">
                            <h3>
                                {{ item.nombre_completo }}
                            </h3>
                        </div>
                        <div class="col-sm-12 mt-3">
                            <label for="" class="form-label">Nombre Completo</label>
                            <input type="text" class="form-control form-control-sm" autocomplete="off"
                                v-model="nombre_completo">
                        </div>
                        <div class="col-sm-12 mt-3">
                            <label for="" class="form-label">Nombre de usuario</label>
                            <input type="text" class="form-control form-control-sm" autocomplete="off"
                                v-model="username">
                        </div>

                        <div class="col-sm-6 mt-3">
                            <label for="" class="form-label">Contraseña</label>
                            <input type="password" class="form-control form-control-sm" autocomplete="off"
                                v-model="password">
                        </div>

                        <div class="col-sm-6 mt-3">
                            <label for="" class="form-label">Confirmar Contraseña</label>
                            <input type="password" class="form-control form-control-sm" autocomplete="off"
                                v-model="confirm_password">
                        </div>
                        <div class="col-sm-12 mt-3">
                            <label for="" class="form-label">Bloquedo</label>
                            <select class="form-control form-control-sm" v-model="bloqueado">
                                <option value="si">Si</option>
                                <option value="no">No</option>
                            </select>
                        </div>
                        <div class="col-sm-12 mt-4 mb-3">
                            <button type="button" class="btn btn-sm btn-outline-dark btn-block" @click="actualizar_">
                                <i class="fas fa-save"></i> Actualizar
                            </button>
                        </div>
                    </b-row>
                </form>

            </b-container>
        </div>
    </div>
</template>

<script>
    import { minix, atexto } from '@/components/functions/alertas'
    import { mapActions } from 'vuex'

    export default {
        name: 'Ficha',
        props: ['item'],
        data() {
            return {
                nombre_completo: '',
                username: '',
                password: '',
                confirm_password: '',
                bloqueado: ''
            }
        },
        methods: {
            cerrar() {
                this.$emit('salir')
            },
            async actualizar_() {
                // Validación del nombre de usuario
                const usuarioRegex = /^[a-z][a-z0-9]{4,}$/;

                if (!usuarioRegex.test(this.username.trim())) {
                    atexto({
                        titulo: 'Incumplimientos', 
                        cuerpo: 'El nombre de usuario debe cumplir con los siguientes requisitos: <br><br>' +
                            '- Mínimo 5 caracteres <br>' +
                            '- No puede contener mayúsculas <br>' +
                            '- No puede iniciar con un número <br>' +
                            '- No puede contener espacios', 
                        icono: 'warning'
                    });
                    return;
                }

                let formulario = {
                    nombre_completo: this.nombre_completo.trim().toUpperCase(),
                    username: this.username.trim().toLowerCase(),
                    blocked: this.bloqueado === 'si' ? true : false
                }

                // Si uno de los campos de contraseña está lleno, ambos deben estarlo
                if (this.password || this.confirm_password) {
                    if (!this.password || !this.confirm_password) {
                        return minix({ icon: 'error', mensaje: 'Ambos campos de contraseña deben estar llenos', tiempo: 3000 })
                    }

                    if (this.password !== this.confirm_password) {
                        return minix({ icon: 'error', mensaje: 'Las contraseñas no coinciden', tiempo: 3000 })
                    }

                    // Validación de contraseña con expresión regular
                    const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[^\s]{8,}$/;

                    if (!passwordRegex.test(this.password)) {
                        return atexto({
                            titulo: 'Incumplimientos',
                            cuerpo: 'La contraseña debe cumplir con los siguientes requisitos: <br><br>' +
                                '- Mínimo 8 caracteres <br>' +
                                '- Al menos una letra mayúscula <br>' +
                                '- Al menos un número <br>' +
                                '- Al menos un caracter especial (!@#$%^&*) <br>' +
                                '- No debe contener espacios',
                            icono: 'warning'
                        });
                    }

                    formulario.password = this.password;
                }

                let f = {
                    id: this.item.id,
                    formulario
                }

                await this.actualizar_usuario(f)
                await this.obtener_lista_usuarios_panel()
            },
            ...mapActions(['actualizar_usuario', 'obtener_lista_usuarios_panel'])
        },
        mounted() {
            this.nombre_completo = this.item.nombre_completo
            this.username = this.item.username
            this.bloqueado = this.item.blocked == true ? 'si' : 'no'
        },
    }
</script>

<style></style>